import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ArticleCard from "../resultcards/ArticleCard.jsx";
import FacetList from "../components/FacetList.jsx";
import Pager from "../components/Pager.jsx";

export default class ListingAlt extends React.Component {
  constructor(props) {
    super(props);
  }

  renderItem = (item, i, nodeId) => {
    const { data, loading, wrapperid } = this.props;
    let classes = 'top-accent' + (nodeId == item.nid ? ' featured' : '');
    
    // console.log(item);
    
    return (
      <div className={classes} key={i}>
        <div className="content-container">
          <ArticleCard
            key={i}
            index={i}
            loading={loading}
            {...item}
          />
        </div>
      </div>
    );
  }

  enableInteractiveBehaviors = () => {
    let active = document.querySelector('.publication-listing .pager__active'),
        buttons = document.querySelectorAll('.publication-listing .pager__next, .publication-listing .pager__prev, .publication-listing .btn--pager'),
        sups = document.querySelectorAll('.article-container sup');

    if (active && buttons && buttons.length > 0) {
      buttons.forEach((el) => {
        if (el.textContent != active.textContent) {
          el.removeEventListener('click', this.handleButtonClick);
          el.addEventListener('click', this.handleButtonClick);
        }
      });
    }

    if (sups && sups.length > 0) {
      sups.forEach((el) => {
        const insideLink = el.querySelector('a');
        if (insideLink) {
          el.textContent = insideLink.textContent;
        }
        else {
          const outsideLink = el.parentElement;
          if (outsideLink.nodeName == 'A') {
            let newSup = document.createElement('sup');
            newSup.textContent = el.textContent;
            outsideLink.after(newSup);
            outsideLink.remove();
          }
        }
      });
    }
  }

  handleButtonClick = () => {
    let article = document.querySelector('.article-body');
    if (!article.classList.contains('hide-article')) {
      article.classList.add('hide-article');
      // document.querySelector('.publication-listing .search__pager-wrapper').scrollIntoView();
      window.scrollTo(0,0);
    }
  }

  render() {
    const { config, data, handleUpdate, loading } = this.props;
    const {
      checkboxLabel = 'Mark to make your selection',
      checkboxType,
      altClass = true,
      dateFormat,
      dictionary,
      eventLinksDivider,
      eventTypeLinks,
      facetsLinks,
      forceFilters,
      hiddenFacets,
      id,
      nodeId,
      perPageOptions,
      showCalendar,
      dateType = 'default',
      dateLabelFormat = 'MMMM do, yyyy',
      resultsOnly,
      showEventTypeLinks,
      showFacetAsLinks,
      showNewKey,
      showResultsSummary,
      sorters,
    } = config;
    const { request, results, totalResults } = data;
    const { resultsTitle, searchBoxLabel, sortLabel, title, perPageLabelBefore, perPageLabelAfter } = dictionary;
    let facets = data.facets;

    const queryInfo = {
      label: searchBoxLabel,
      id: id + 'query',
      handleUpdate: handleUpdate,
      q: request.q
    };

    const dateInfo = showCalendar ? {
      endDate: (request.endDate) ? request.endDate : '',
      id: id,
      showLabel: true,
      startDate: (request.startDate) ? request.startDate : '',
    } : false;

    // If the hidden facets option is enabled remove those from the regular facets list.
    // Can be used alongside the Facets Toggles to improve UX and navigation.
    if (typeof showFacetAsLinks !== 'undefined' && showFacetAsLinks) {
      const facetsList = (typeof facetsLinks !== 'undefined') ? facetsLinks.map((link) => link.id) : [];
      if (facetsList && facets && hiddenFacets) {
        facets = facets.filter((item) => (hiddenFacets.indexOf(item.id) === -1));
      }
    }

    const showFacets = facets && facets.length > 0 || forceFilters;

    const searchClass = classNames('search', {
      'is-loading': loading
    });

    return (
      <div className={ searchClass }>
        <div className="visually-hidden" aria-live="polite">{ loading && "Loading" } { !loading && "Loading Complete" }</div>
        {showFacets && !resultsOnly && <FacetList
          checkboxType={ checkboxType }
          checkboxLabel={ checkboxLabel }
          altClass={ altClass }
          dateType={ dateType }
          dateInfo={ dateInfo }
          dictionary={ dictionary }
          facets={ facets }
          selectedFacets={ request.facet }
          selectedFacetsPosition={ "bottom" }
          handleUpdate = { (params) =>{
              handleUpdate(params);
            }
          }
          dateLabelFormat={ dateLabelFormat }
          horizontal={ true }
          queryInfo={ queryInfo }
          dateLabelFormat={ dateLabelFormat } /> }
        { results.length > 0 && <div className="results">
          { results.map((result, i) => this.renderItem(result, i, nodeId)) }
        </div> }
        <div className="search__pager-wrapper">
        { results.length > 0 && <Pager
          handleUpdate = { handleUpdate }
          page={ parseInt(request.page) }
          perPage={ parseInt(request.perPage) }
          totalResults={ totalResults } /> }
        </div>
      </div>
    );
  }

  componentDidMount() {
    const hash = document.location.hash,
    el = hash ? document.querySelector(hash) : false;
    if (el) {
      el.scrollIntoView();
    }
    this.enableInteractiveBehaviors();
  }

  componentDidUpdate() {
    this.enableInteractiveBehaviors();
  }
}

const { bool, func, object} = PropTypes;

ListingAlt.propTypes= {
  config: object.isRequired,
  data: object.isRequired,
  handleUpdate: func.isRequired,
  loading: bool
};
